module.exports = __webpack_public_path__ + "img/c05_buildingtecharchconstruction_Normal_ua.b9ae188f.webp";